import React, { Component } from "react";
import { storage } from "../../firebase";
import "./style.css";
import {
  DatePicker,
  notification,
  Popconfirm,
  message,
  Radio,
  Form,
  Input,
  Button,
  Select,
  Divider,
  Progress,
} from "antd";
import "tachyons";
import { FormGroup, Label, CustomInput, Row, Col } from "reactstrap";
import {
  CheckCircleTwoTone,
  QuestionCircleOutlined,
  UserOutlined,
  LockOutlined,
  IdcardOutlined,
  SkypeOutlined,
} from "@ant-design/icons";
import { Redirect } from "react-router";
import type { RadioChangeEvent } from "antd";

const key = "updatable";
const { Option } = Select;

class ApplicantForm extends Component {
  constructor() {
    super();
    this.state = {
      //BIO Related - Form
      id: "",
      name: "",
      cnic: "",
      dob: "",
      gender: "",
      phone: "",
      secondaryPhone: "",
      email: "",
      address: "",
      city: "",
      provinceRegion: "",

      //Password
      password: "",
      password2: "",

      //HR Related - Form
      skypeId: "",
      experience: "",
      reference: "",
      windowsVersion: "",
      prevOrganizations: "",
      learning: "",

      //Applicant Status
      applicantStatus: "",
      //Recruit Status
      recruitStatus: "",
      selectedRoles: [],
      // shiftTime: "",
      selectedShift: "",
      batch: "",
      verticle: "",

      //From Selected Job
      designation: "",
      department: "",
      salaryType: "",
      location: "",
      schedule: "",

      //Other
      netSpeedImageProgress: 0,
      netSpeedImageUrl: "",
      netSpeedImage: "",
      checkEmailInput: false,
      loader: false,

      //Status
      submittedForm: [],
      errors: {},

      selectedFile: "",
      ResumeProgress: 0,
      resumeUrl: "",
    };
  }

  onChangeRadio = (e: RadioChangeEvent) => {
    console.log("radio checked", e.target.value);
    this.setState({ learning: e.target.value });
  };

  componentDidMount() {
    const { selectedJob } = this.props;
    var todayDate = new Date();

    console.log("selectedJob: ", selectedJob);
    if (selectedJob) {
      this.setState(
        {
          department: selectedJob.department,
          program: selectedJob.program,
          designation: selectedJob.designation,
          salaryType: selectedJob.salaryType,
          location: selectedJob.location,
          schedule: selectedJob.schedule,
          selectedRoles: selectedJob.selectedRoles,
          // shiftTime: selectedJob.shiftTime,
          selectedShift: selectedJob.selectedShift,
          verticle: selectedJob.verticle,
          //Applicant Status
          applicantStatus: {
            phase1: {
              currentProgress: 1,
              applied: todayDate.toLocaleString(),
              viewed: "",
              contacted: "",
              resolution: "",
              phaseStatus: false,
            },
            offerLetterStatus: { issueDate: "", status: "" },
            batch: selectedJob.batch,
            phase2: {
              currentProgress: 0,
              trainingDate: "",
              jointTraining: false,
              trainingSessionLink: "",
              phaseStatus: false,
            },
            finalStatus: "Applicant",
          },

          //Recruit Status
          recruitStatus: {
            finalStatus: "",
          },
        },
        () => {
          console.log("Selecetd Job: ", selectedJob);
          console.log("Updated State of Form", this.state);
        }
      );
    } else {
      const args = {
        message: "Kindly select a job.",
        duration: 5,
        placement: "topLeft",
        top: 100,
      };
      notification.info(args);
    }
  }

  handleChange = (value) => {
    if (value) {
      const dateFormat = value.format("YYYY-MM-DD");
      this.setState({ dob: dateFormat });
    }
  };

  onChange = (e) => {
    if (e.target.name === "email") {
      console.log(this.state);
      this.setState({
        [e.target.name]: e.target.value.toLowerCase(),
        checkEmailInput: true,
      });
    } else {
      this.setState({ [e.target.name]: e.target.value });
      console.log(this.state);
    }
  };

  onChangeGender = (value) => {
    this.setState({ gender: value });
    console.log(this.state);
  };

  onChangeReasoneXP = (value) => {
    this.setState({ experience: value });
    console.log(this.state);
  };

  onChangeReason1 = (value) => {
    this.setState({ reference: value });
    console.log(this.state);
  };

  onChangeReason2 = (value) => {
    this.setState({ windowsVersion: value });
    console.log(this.state);
  };

  handleFiles = (e) => {
    if (e.target.files[0]) {
      this.setState({ netSpeedImage: e.target.files[0] }, () => {
        this.handelUpload();
      });
    }
  };

  handleResumeUpload = () => {
    console.log("Resume upload function: ", "this.handleResumeUpload");
    const { selectedFile, email } = this.state;
    const uploadResume = storage.ref(`Resumes/${email}`).put(selectedFile);

    uploadResume.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        this.setState({ netSpeedImageProgress: progress });
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("Resumes/")
          .child(email)
          .getDownloadURL()
          .then((url) => {
            this.setState({ resumeUrl: url });
          });
      }
    );
    console.log("HandleResumeUpload function ends");
  };

  handelUpload = () => {
    const { netSpeedImage, email } = this.state;
    const uploadScreenshot = storage
      .ref(`internetSpeedScreenshots/${email}`)
      .put(netSpeedImage);

    uploadScreenshot.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        this.setState({ netSpeedImageProgress: progress });
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("internetSpeedScreenshots/")
          .child(email)
          .getDownloadURL()
          .then((url) => {
            this.setState({ netSpeedImageUrl: url });
          });
      }
    );
  };
  onChangeSchedule = (value) => {
    this.setState({ schedule: value });
  };

  onSubmit = () => {
    const { selectedJob } = this.props;
    var gender = "";
    if (selectedJob.gender === "Female") {
      gender = "Female";
    } else if (selectedJob.gender === "Male") {
      gender = "Male";
    } else if (selectedJob.gender === "Both") {
      gender = this.state.gender;
    }

    console.log("Submit function called", this.state);
    message.loading({
      content: "Submitting..",
      key,
      style: {
        marginTop: "10vh",
      },
    });
    this.setState({ loader: true });

    let object = {
      //BIO Related - Form
      name: this.state.name,
      cnic: this.state.cnic,
      dob: this.state.dob,
      gender: gender,
      phone: this.state.phone,
      secondaryPhone: this.state.secondaryPhone,
      email: this.state.email,
      address: this.state.address,
      city: this.state.city,
      provinceRegion: this.state.provinceRegion,
      //Password
      password: this.state.password,
      password2: this.state.password2,
      //HR Related - Form
      skypeId: this.state.skypeId,
      netSpeedImage: this.state.netSpeedImageUrl,
      resume: this.state.resumeUrl,
      experience: this.state.experience,
      reference: this.state.reference,
      windowsVersion: this.state.windowsVersion,
      prevOrganizations: this.state.prevOrganizations,
      applicantStatus: this.state.applicantStatus,
      recruitStatus: this.state.recruitStatus,
      //From Selected Job
      designation: this.state.designation,
      department: this.state.department,
      program: this.state.program,
      salaryType: this.state.salaryType,
      location: this.state.location,
      schedule: this.state.schedule,
      selectedRoles: this.state.selectedRoles,
      // shiftTime: this.state.shiftTime,
      selectedShift: this.state.selectedShift,
      verticle: this.state.verticle,

      nodemailerType: "register",
      nodemailerName: this.state.name,
      nodemailerEmail: this.state.email,
      nodemailerDesignation: this.state.designation,
      learning: this.state.learning,
    };

    setTimeout(() => {
      // For CP
      fetch(
        "https://work-web-server.herokuapp.com/hiring/applicants/register",
        // "http://localhost:5000/hiring/applicants/register",
        {
          method: "POST",
          // mode: 'no-cors',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(object),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          console.log("response from server ", response);
          if (response._id) {
            this.setState({
              id: response._id,
              submittedForm: response,
              loader: false,
            });

            message.success({
              content: "Form Submitted Successfully",
              key,
              duration: 2,
              style: {
                marginTop: "10vh",
              },
            });
          } else if (response && !response._id) {
            console.log(response);
            this.setState({
              loader: false,
              errors: response,
            });

            message.warning({
              content: "Invalid Enteries!",
              key,
              duration: 2,
              style: {
                marginTop: "10vh",
              },
            });
          } else {
            console.log(response);
          }
          console.log(this.state);
        })
        .catch((error) => {
          // this.setState({ errorMessage: error.toString() });
          this.setState({
            loader: false,
          });
          message.warning({
            content: `Connection Failed!: ${error}`,
            key,
            duration: 4,
            style: {
              marginTop: "10vh",
            },
          });
          console.error("There was an error!", error);
        });
    }, 1000);
  };

  openFormNotification = () => {
    let placement = "bottomRight";
    notification.open({
      message: `Congratulations ${this.state.name}!`,
      description: (
        <div id="loading">
          <p>Your Job Application has been submitted Successfully</p>
          <p>WORK HR will get back to you as soon as posible.</p>
          <h6>All The Best</h6>
        </div>
      ),
      duration: 6,
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
      placement,
    });
  };

  normFile = (e) => {
    console.log("Upload event:", e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  confirm = (e) => {
    console.log(this.state);
    if (
      this.state.phone.length !== 9 ||
      this.state.secondaryPhone.length !== 9 ||
      this.state.cnic.length !== 13
    ) {
      return null;
      alert("length error");
    }
    if (this.props.selectedJob) {
      this.onSubmit();
    } else {
      alert("Please refresh your page and try again, thanks.");
    }
  };

  cancel = (e) => {
    console.log(e);
    message.error({
      content: "Submission Canceled",
      style: {
        marginTop: "10vh",
      },
    });
    this.setState({
      //BIO Related - Form
      id: "",
      name: "",
      cnic: "",
      dob: "",
      gender: "",
      phone: "",
      secondaryPhone: "",
      email: "",
      address: "",
      city: "",
      provinceRegion: "",

      //Password
      password: "",
      password2: "",

      //HR Related - Form
      skypeId: "",
      netSpeedImageUrl: "",
      experience: "",
      reference: "",
      windowsVersion: "",
      prevOrganizations: "",
      netSpeedImage: "",
    });
  };

  onFinish = (values) => {
    console.log("Success:", values);
    this.onSubmit();
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  changeHandler = (event) => {
    this.setState({ selectedFile: event.target.files[0] }, () => {
      this.handleResumeUpload();
    });
  };

  render() {
    const { errors } = this.state;
    if (!this.props.selectedJob) {
      return <Redirect to="/jobs" />;
    }
    const { selectedJob } = this.props;
    return (
      <div className="animate__animated animate__zoomInDown form">
        <Form
          scrollToFirstError={true}
          initialValues={{ remember: true }}
          onFinish={this.onFinish}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          labelAlign="left"
        >
          <Row xs="1" sm="3" md="3">
            <Col className="firstForm">
              <br />
              <Form.Item
                name="name"
                label="Full Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter your name!",
                  },
                ]}
              >
                <Input
                  name="name"
                  value={this.state.name}
                  onChange={this.onChange}
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="Full Name"
                />
              </Form.Item>

              {/* <Label className="red">{errors.cnic}</Label> */}
              <Form.Item
                name="cnic"
                label="C.N.I.C."
                rules={[
                  {
                    required: true,
                    message: "Please enter your CNIC!",
                  },
                  {
                    len: 13,
                    message: "CNIC format or length is incorrect",
                  },
                ]}
              >
                <Input
                  type="number"
                  name="cnic"
                  value={this.state.cnic}
                  onChange={this.onChange}
                  prefix={<IdcardOutlined className="site-form-item-icon" />}
                  placeholder="CNIC (without dashes)"
                />
              </Form.Item>

              {/* <Label className="red">{errors.dob}</Label> */}
              <Form.Item
                name="dob"
                label="DOB"
                rules={[
                  {
                    required: true,
                    message: "Please select your DOB!",
                  },
                ]}
              >
                <DatePicker name="dob" onChange={this.handleChange} />
              </Form.Item>
              {/* <Label className="red">{errors.gender}</Label> */}
              <Form.Item
                name="gender"
                label="Gender"
                rules={
                  selectedJob.gender === "Both"
                    ? [{ required: true, message: "Please select gender!" }]
                    : null
                }
              >
                {selectedJob.gender === "Both" ? (
                  <Select
                    name="gender"
                    placeholder="select your gender"
                    onChange={this.onChangeGender}
                  >
                    <Option value="Male">Male</Option>
                    <Option value="Female">Female</Option>
                    <Option value="Other">Other</Option>
                  </Select>
                ) : (
                  <p>{selectedJob.gender}</p>
                )}
              </Form.Item>

              {/* <Label className="red">{errors.phone}</Label> */}
              <Form.Item
                name="phone"
                label="Phone Number"
                rules={[
                  {
                    required: true,
                    message: "Please enter your phone number!",
                  },
                  {
                    len: 10,
                    message: "Phone number length is invalid",
                  },
                ]}
              >
                <Input
                  type="number"
                  name="phone"
                  value={this.state.phone}
                  onChange={this.onChange}
                  addonBefore={"+92"}
                  style={{ width: "100%" }}
                />
              </Form.Item>
              {/* <Label className="red">{errors.secondaryPhone}</Label> */}
              <Form.Item
                name="secondaryPhone"
                label="Emergency Number"
                rules={[
                  {
                    required: true,
                    message: "Please enter your secondary phone number!",
                  },
                  {
                    len: 10,
                    message: "Phone number length is invalid",
                  },
                ]}
              >
                <Input
                  type="number"
                  name="secondaryPhone"
                  value={this.state.secondaryPhone}
                  onChange={this.onChange}
                  addonBefore={"+92"}
                  style={{ width: "100%" }}
                />
              </Form.Item>

              {/* <Label className="red">{errors.address}</Label> */}
              <Form.Item
                name="address"
                label="Address"
                rules={[
                  {
                    required: true,
                    message: "Please enter your Address!",
                  },
                ]}
              >
                <Input
                  name="address"
                  value={this.state.address}
                  onChange={this.onChange}
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="Address"
                />
              </Form.Item>

              {/* <Label className="red">{errors.city}</Label> */}
              <Form.Item
                name="city"
                label="City"
                rules={[
                  {
                    required: true,
                    message: "Please enter your City!",
                  },
                ]}
              >
                <Input
                  name="city"
                  value={this.state.city}
                  onChange={this.onChange}
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="City"
                />
              </Form.Item>
              {/* <Label className="red">{errors.provinceRegion}</Label> */}
              <Form.Item
                name="provinceRegion"
                label="Province/Region"
                rules={[
                  {
                    required: true,
                    message: "Please enter your province/Region!",
                  },
                ]}
              >
                <Input
                  name="provinceRegion"
                  value={this.state.provinceRegion}
                  onChange={this.onChange}
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="Province/Region"
                />
              </Form.Item>
            </Col>

            <Col className="secondForm">
              <Label className="red">{errors.email}</Label>
              <Form.Item
                name="email"
                label="E-mail"
                rules={[
                  {
                    type: "email",
                    message: "The input is not a valid E-mail!",
                  },
                  {
                    required: true,
                    message: "Please enter your E-mail!",
                  },
                ]}
              >
                <Input
                  name="email"
                  value={this.state.email}
                  onChange={this.onChange}
                  placeholder="Email"
                />
              </Form.Item>
              <Label className="red">{errors.skypeId}</Label>
              {/* <Form.Item name="skypeId" label="Skype ID">
                <Input
                  name="skypeId"
                  value={this.state.skypeId}
                  onChange={this.onChange}  
                  prefix={<SkypeOutlined className="site-form-item-icon" />}
                  placeholder="Skype ID"
                />
              </Form.Item> */}
              {/* <Label className="red">{errors.experience}</Label> */}

              {selectedJob.schedule === "Any" ? (
                <Form.Item label="Select Schedule">
                  <Select
                    name="schedule"
                    onChange={this.onChangeSchedule}
                    placeholder="select your schedule"
                  >
                    <Option value="Part-Time">Part-Time</Option>
                    <Option value="Full-Time">Full-Time</Option>
                  </Select>
                </Form.Item>
              ) : null}

              <Form.Item
                name="experience"
                label="Experience"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please select experience!",
                //   },
                // ]}
              >
                <Select
                  name="experience"
                  placeholder="select your experience"
                  onChange={this.onChangeReasoneXP}
                >
                  <Option value="Fresh">Fresh</Option>
                  <Option value="3">3</Option>
                  <Option value="6">6</Option>
                  <Option value="9">9</Option>
                  <Option value="12">12</Option>
                  <Option value="18">18</Option>
                  <Option value="24">24</Option>
                  <Option value="36">36</Option>
                  <Option value="48">48</Option>
                  <Option value="60">60</Option>
                  <Option value="60+">60+</Option>
                </Select>
              </Form.Item>

              {/* <Label className="red">{errors.reference}</Label> */}
              <Form.Item
                name="foundAboutUs"
                label="Question"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please select a source!",
                //   },
                // ]}
              >
                <Select
                  name="foundAboutUs"
                  placeholder="How did you find out about us?"
                  onChange={this.onChangeReason1}
                >
                  {/* <Option value="EBP - Economic Planning Board">
                    EBP - Economic Planning Board
                  </Option> */}
                  <Option value="Facebook">Facebook</Option>
                  <Option value="LinkedIN">LinkedIN</Option>
                  <Option value="Indeed Job Portal">Indeed Job Portal</Option>
                  {/* <Option value="Haseeb Waheed">Haseeb Waheed</Option> */}
                  <Option value="Referred by WORK employee">
                    Referred by WORK employee
                  </Option>
                  <Option value="Instagram">Instagram</Option>
                  <Option value="Ali Janjua">Ali Janjua</Option>
                  <Option value="Referred by a friend">
                    Referred by a friend
                  </Option>
                  <Option value="Rozee.pk">Rozee.pk</Option>
                  <Option value="Career Expo/ Job Fair">
                    Career Expo/ Job Fair
                  </Option>
                  <Option value="OLX">OLX</Option>
                  {/* <Option value="Newspaper">Newspaper</Option> */}
                  {/* <Option value="University Graduates">
                    University Graduates
                  </Option> */}
                  {/* <Option value="Facebook leads">Facebook leads</Option> */}
                </Select>
              </Form.Item>

              {/*  <Label className="red">{errors.windowsVersion}</Label> */}
              <Form.Item
                name="windowsVersion"
                label=" Windows Version"
                rules={[
                  {
                    required: true,
                    message: "Please select a windows version!",
                  },
                ]}
              >
                <Select
                  name="windowsVersion"
                  placeholder="Windows version installed on your PC"
                  onChange={this.onChangeReason2}
                >
                  <Option value="8">8</Option>
                  {/* <Option value="9">9</Option> */}
                  <Option value="10">10</Option>
                  <Option value="OTHER">OTHER</Option>
                </Select>
              </Form.Item>

              {/* <Label className="red">{errors.prevOrganizations}</Label> */}
              <Form.Item
                label="Previous Organizations"
                name="prevOrganizations"
              >
                <Input
                  name="prevOrganizations"
                  value={this.state.prevOrganizations}
                  onChange={this.onChange}
                  placeholder="Previous Organizations"
                />
              </Form.Item>
              {this.props.selectedJob ? (
                this.props.selectedJob.department &&
                this.props.selectedJob.department === "Operations" ? (
                  <FormGroup>
                    <Form.Item
                      name="customFile"
                      label="Upload Screen-shot"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message:
                      //       "Please upload a screen-shot of you Internet speed!",
                      //   },
                      // ]}
                    >
                      <CustomInput
                        // disabled={!this.state.checkEmailInput}
                        type="file"
                        id="exampleCustomFileBrowser"
                        name="customFile"
                        label="Screen-shot of your Internet speed"
                        onChange={this.handleFiles}
                      >
                        {this.state.netSpeedImageProgress === 0 ? null : (
                          <Progress
                            id="netSpeedImageProgress"
                            percent={this.state.netSpeedImageProgress}
                          />
                        )}
                      </CustomInput>
                    </Form.Item>
                  </FormGroup>
                ) : (
                  <Form.Item
                    name="resume"
                    label="Upload Resume (pdf)"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Please upload your resume!",
                    //   },
                    // ]}
                  >
                    <div className="file-uploader">
                      <input
                        type="file"
                        name="file"
                        accept="application/pdf"
                        onChange={this.changeHandler}
                      />
                    </div>
                  </Form.Item>
                )
              ) : null}
            </Col>

            <Col>
              <br />
              <br />
              <br />
              <div className="tc">
                <Radio.Group onChange={this.onChangeRadio}>
                  <Radio value={"regularLearning"}>Regular Learning</Radio>
                  <Radio value={"selfLearning"}>Self Learning</Radio>
                </Radio.Group>
              </div>
              <br />
              <br />
              <br />

              <Divider>
                <h5 className="tc formSubmissionHeader">
                  {this.props.selectedJob
                    ? "Applying for WORK - " + this.props.selectedJob.jobTitle
                    : "APPLY@W4WORK"}
                </h5>
              </Divider>

              <Label className="red">{errors.password}</Label>
              <Form.Item
                name="password"
                label="Create Password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your Password!",
                  },
                ]}
                hasFeedback
              >
                <Input.Password
                  name="password"
                  value={this.state.password}
                  onChange={this.onChange}
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Password"
                />
              </Form.Item>
              <Label className="red">{errors.password2}</Label>
              <Form.Item
                name="password2"
                label="Confirm Password"
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message:
                      "Please enter your password again for confirmation!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject("Passwords do not match");
                    },
                  }),
                ]}
                hasFeedback
              >
                <Input.Password
                  name="password2"
                  value={this.state.password2}
                  onChange={this.onChange}
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Re-Enter Password"
                />
              </Form.Item>
              <div className="tc">
                <br />
                <Button
                  className="applyButtonMainScreen heartbeat"
                  htmlType="submit"
                  onClick={() => {
                    this.confirm();
                  }}
                >
                  Submit Applciation
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default ApplicantForm;
